function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.695,27.763H3.203c-0.59,0-1.067-0.479-1.067-1.068v-8.008l7.379-5.531l11.083,11.062 c0.423,0.364,1.057,0.339,1.45-0.056c0.395-0.395,0.418-1.026,0.056-1.449l-3.417-3.438l3.737-2.979l5.34,4.463v5.938 c0,0.283-0.113,0.555-0.313,0.756C27.251,27.649,26.979,27.763,26.695,27.763L26.695,27.763z M3.203,2.136h23.492 c0.283,0,0.555,0.111,0.755,0.312c0.199,0.201,0.312,0.473,0.312,0.756v14.768l-4.655-3.876c-0.395-0.325-0.963-0.325-1.356,0 l-4.592,3.674l-6.802-6.803c-0.376-0.376-0.974-0.417-1.399-0.096l-6.822,5.146V3.203C2.136,2.613,2.613,2.136,3.203,2.136 L3.203,2.136z M26.695,0H3.203C1.435,0,0,1.435,0,3.203v23.491c0,1.77,1.435,3.203,3.203,3.203h23.492 c1.769,0,3.203-1.434,3.203-3.203V3.203C29.898,1.435,28.464,0,26.695,0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.755,6.407c0.65,0,1.236,0.394,1.481,0.996c0.246,0.604,0.104,1.294-0.361,1.75c-0.466,0.456-1.16,0.585-1.756,0.328 c-0.599-0.259-0.979-0.854-0.967-1.503C18.17,7.104,18.882,6.407,19.755,6.407L19.755,6.407z M19.755,11.746 c1.508,0,2.869-0.908,3.448-2.3c0.581-1.393,0.267-2.998-0.795-4.068c-1.062-1.072-2.665-1.401-4.062-0.832 c-1.398,0.568-2.316,1.921-2.33,3.43c-0.008,0.997,0.381,1.956,1.084,2.663C17.801,11.348,18.757,11.746,19.755,11.746 L19.755,11.746z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.898 29.897",
    enableBackground: "new 0 0 29.898 29.897",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/image.7ae2b1ac.svg";
export { SvgComponent as ReactComponent };